import React from "react";
import { ViewerFigure } from "../../_shared/figure/viewer-figure.js";
import { Giphy } from "./giphy.js";
const ViewerGiphy = ({
  node,
  nodeIndex,
  NodeViewContainer,
  RicosNodesRenderer
}) => {
  return /* @__PURE__ */ React.createElement(
    ViewerFigure,
    {
      node,
      nodeIndex,
      NodeViewContainer,
      RicosNodesRenderer
    },
    /* @__PURE__ */ React.createElement(Giphy, { componentData: node.gifData, nodeId: node.id })
  );
};
const GiphyRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(ViewerGiphy, { key: node.id, node, ...props });
};
var viewer_giphy_default = GiphyRenderer;
export {
  viewer_giphy_default as default
};
//# sourceMappingURL=viewer-giphy.js.map

import "@wix/ricos/css/plugin-giphy-viewer.global.css";